module.exports = __webpack_public_path__ + "static/media/acecoinlogo-2x.35d422f3.png";